import React from "react";

import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import NumberValue from "../../components/NumberValue";



const TabMatches: React.FC = () => {
  const stats = useSelector((state: RootState) => state.stats);

  return (
    <Stack direction="column" spacing={4}>
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Matches</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Total</TableCell>
              <TableCell align="right"><NumberValue number={stats.matches?.total}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Active</TableCell>
              <TableCell align="right"><NumberValue number={stats.matches?.active}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Deleted</TableCell>
              <TableCell align="right"><NumberValue number={stats.matches?.deleted}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Swipes</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Total</TableCell>
              <TableCell align="right"><NumberValue number={stats.swipes?.total}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Likes</TableCell>
              <TableCell align="right"><NumberValue number={stats.swipes?.likes}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Dislikes</TableCell>
              <TableCell align="right"><NumberValue number={stats.swipes?.dislikes}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

    </Stack>
  );
};

export default TabMatches;